import { useEffect, useState } from "react";
import { api } from "../lib/api";
import FoodCard from "../components/FoodCard";

export default function Menu() {
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [allergensVocab, setAllergensVocab] = useState([]);
  const [active, setActive] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/menu");
        setItems(data.items);
        setCategories(["All", ...data.categories]);
        setAllergensVocab(data.allergens || []);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const visible = active === "All" ? items : items.filter((i) => i.category === active);

  return (
    <main data-testid="menu-page" className="max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-14">
        <div>
          <span className="font-label text-xs text-[#1A6B2E]">The menu</span>
          <h1 className="font-display text-5xl md:text-7xl mt-3 leading-[0.95] tracking-tighter">
            Snacks, meals & <br className="hidden md:block" />
            everything <span className="text-[#1A6B2E]">crunchy</span>.
          </h1>
        </div>
        <div className="flex flex-wrap gap-2" data-testid="menu-filters">
          {categories.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => setActive(c)}
              className={`rounded-full px-5 py-2.5 text-sm font-medium border transition-colors ${
                active === c
                  ? "bg-[#0E2B13] text-[#FDFBF7] border-[#0E2B13]"
                  : "bg-white text-[#0E2B13] border-[#1A6B2E]/15 hover:bg-[#F4EFEB]"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="chop-card chop-shadow overflow-hidden animate-pulse">
              <div className="aspect-[4/3] bg-[#F4EFEB]" />
              <div className="p-6 space-y-3">
                <div className="h-5 bg-[#F4EFEB] rounded w-2/3" />
                <div className="h-3 bg-[#F4EFEB] rounded w-full" />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {visible.map((item, i) => (
            <FoodCard key={item.id} item={item} index={i} allergensVocab={allergensVocab} />
          ))}
        </div>
      )}
    </main>
  );
}
